import React, { Component } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cssTransition, toast, ToastContainer } from 'react-toastify';

import { APIHandler, AttendeeForm, StorageHandler } from 'config/C4';
import { storageKeys } from 'config/settings';

import 'react-toastify/dist/ReactToastify.css';

const checkDateInPast = (firstDate, secondDate) =>
  firstDate.setHours(0, 0, 0, 0) <= secondDate.setHours(0, 0, 0, 0);

const Zoom = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  duration: [500, 800],
});

export default class AttendeeView extends Component {
  constructor() {
    super();
    this.state = {
      events: [],
      shows: [],
      meetings: [],
      individualShow: false,
      individualShowData: [],
      loading: true,
      date: '',
      popup: false,
      popupLoader: false,
      signedUpFor: [],
      icsDownloaded: false,
    };

    this.getEvents = this.getEvents.bind(this);
    this.getShowsToSignUp = this.getShowsToSignUp.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleMeetingOptIn = this.handleMeetingOptIn.bind(this);
    this.meetingOptIn = this.meetingOptIn.bind(this);
    this.openPopup = this.openPopup.bind(this);
    this.closePopup = this.closePopup.bind(this);
  }

  async componentDidMount() {
    await this.getEvents();

    this.sortEvents();
    this.getShowsToSignUp();

    if (
      window.location.hostname === 'register.theallamericanroadshow.com' ||
      window.location.hostname === 'theallamericanroadshow.com' ||
      window.location.hostname === 'www.theallamericanroadshow.com'
    ) {
      this.setState({
        individualShow: true,
        // showName: 'aars',
      });
      this.getIndividualShowData(1467);
      this.setShowDate();
      this.setLoading(false);
    } else if (
      window.location.hostname === 'register.adventuretravelxpo.com' ||
      window.location.hostname === 'adventuretravelxpo.com' ||
      window.location.hostname === 'www.adventuretravelxpo.com'
    ) {
      this.setState({
        individualShow: true,
        // showName: 'adventure',
      });
      this.getIndividualShowData(1854);
      this.setShowDate();
      this.setLoading(false);
    } else if (
      window.location.hostname === 'register.familytravelxpo.com' ||
      window.location.hostname === 'familytravelxpo.com' ||
      window.location.hostname === 'www.familytravelxpo.com'
    ) {
      this.setState({
        individualShow: true,
        // showName: 'family',
      });
      this.getIndividualShowData(1851);
      this.setShowDate();
      this.setLoading(false);
    } else if (
      window.location.hostname === 'register.europetravelxpo.com' ||
      window.location.hostname === 'europetravelxpo.com' ||
      window.location.hostname === 'www.europetravelxpo.com'
    ) {
      this.setState({
        individualShow: true,
        // showName: 'europe',
      });
      this.getIndividualShowData(1403);
      this.setShowDate();
      this.setLoading(false);
    } else if (
      // dev url for testing of the meeting opt-in feature
      window.location.hostname === 'deploy-preview-3--romancetravelxpo.netlify.app' ||
      window.location.hostname === 'register.romancetravelxpo.com' ||
      window.location.hostname === 'romancetravelxpo.com' ||
      window.location.hostname === 'www.romancetravelxpo.com'
    ) {
      this.setState({
        individualShow: true,
        // showName: 'romance',
      });
      this.getIndividualShowData(1855);
      this.setShowDate();
      this.setLoading(false);
    } else if (
      window.location.hostname === 'register.luxurytravelxpo.com' ||
      window.location.hostname === 'luxurytravelxpo.com' ||
      window.location.hostname === 'www.luxurytravelxpo.com'
    ) {
      this.setState({
        individualShow: true,
        // showName: 'luxury',
      });
      this.getIndividualShowData(1853);
      this.setShowDate();
      this.setLoading(false);
    } else {
      this.setLoading(false);
    }
  }

  handleChange(event) {
    const { id } = event.target;
    const { shows } = this.state;
    const showsArray = shows;

    if (showsArray.length > 0 && showsArray.includes(id)) {
      const index = showsArray.indexOf(id);
      if (index > -1) {
        showsArray.splice(index, 1);
      }
      this.setState({ shows: showsArray });
      return;
    }

    showsArray.push(id);
    this.setState({ shows: showsArray });
  }

  async getEvents() {
    await APIHandler.getEvents().then((res) => {
      if (res) {
        const eventsArray = Object.values(res);

        if (eventsArray && eventsArray[0] && eventsArray[0][0]) {
          this.setState({
            events: eventsArray[0][0],
          });
        }
      }
    });
  }

  setLoading(loading) {
    this.setState({ loading });
  }

  async getShowsToSignUp() {
    if (
      window.location.hostname === 'register.theallamericanroadshow.com' ||
      window.location.hostname === 'theallamericanroadshow.com' ||
      window.location.hostname === 'www.theallamericanroadshow.com'
    ) {
      await StorageHandler.save(storageKeys.showsToSignUp, 'aars');
    } else if (
      window.location.hostname === 'register.adventuretravelxpo.com' ||
      window.location.hostname === 'adventuretravelxpo.com' ||
      window.location.hostname === 'www.adventuretravelxpo.com'
    ) {
      await StorageHandler.save(storageKeys.showsToSignUp, 'adventure');
    } else if (
      window.location.hostname === 'register.familytravelxpo.com' ||
      window.location.hostname === 'familytravelxpo.com' ||
      window.location.hostname === 'www.familytravelxpo.com'
    ) {
      await StorageHandler.save(storageKeys.showsToSignUp, 'family');
    } else if (
      window.location.hostname === 'register.luxurytravelxpo.com' ||
      window.location.hostname === 'luxurytravelxpo.com' ||
      window.location.hostname === 'www.luxurytravelxpo.com'
    ) {
      await StorageHandler.save(storageKeys.showsToSignUp, 'luxury');
    } else if (
      // dev url for testing of the meeting opt-in feature
      window.location.hostname === 'deploy-preview-3--romancetravelxpo.netlify.app' ||
      window.location.hostname === 'register.romancetravelxpo.com' ||
      window.location.hostname === 'romancetravelxpo.com' ||
      window.location.hostname === 'www.romancetravelxpo.com'
    ) {
      await StorageHandler.save(storageKeys.showsToSignUp, 'romance');
    } else if (
      window.location.hostname === 'register.europetravelxpo.com' ||
      window.location.hostname === 'europetravelxpo.com' ||
      window.location.hostname === 'www.europetravelxpo.com'
    ) {
      await StorageHandler.save(storageKeys.showsToSignUp, 'europe');
    }

    const showsToSignUp = (await StorageHandler.load(storageKeys.showsToSignUp)) || [];
    this.setState({
      shows: showsToSignUp,
    });
  }

  getIndividualShowData(id) {
    const { events } = this.state;
    const individualShow = events.filter((item) => item.id === id);
    this.setState({
      individualShowData: individualShow[0],
    });
  }

  async meetingOptIn(appId) {
    const { accessToken } = this.state;

    if (appId) {
      if (accessToken) {
        APIHandler.addMeetingRequest(appId, accessToken).then((res) => {
          toast.success('Meeting preferences updated', {
            position: 'bottom-center',
            transition: Zoom,
            autoClose: 10000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        });
      } else {
        // Store meetings opt-in for later processing when user logs in
        StorageHandler.save(storageKeys.meetingsOptIn, appId);
      }
    }
  }

  handleMeetingOptIn(appId) {
    const { meetings } = this.state;

    this.meetingOptIn(appId);

    if (meetings.includes(appId)) {
   
      return;
    }
    meetings.push(appId);
    this.setState({ meetings });
  }

  setShowDate() {
    const { individualShowData } = this.state;
    if (individualShowData) {
      const t = individualShowData.start_date.split(/[- :]/);

      // Apply each element to the Date function
      const d = new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
      const startDate = new Date(d);

      const month = startDate.toLocaleString('en-us', { month: 'long' });
      const day = startDate.getDate();
      const year = startDate.getFullYear();

      this.setState({
        date: `${month} ${day}, ${year}`,
      });
    }
  }

  sortEvents() {
    const { events } = this.state;

    const upcomingEventsArray = [];
    const previousEventsArray = [];
    if (events) {
      events.forEach((item) => {
        if (item.start_date !== '0000-00-00 00:00:00') {
          const eventDate = new Date(item.start_date);
          const today = new Date();
          if (checkDateInPast(eventDate, today) === true) {
            previousEventsArray.push(item);
          } else {
            upcomingEventsArray.push(item);
          }
        }
      });

      if (upcomingEventsArray.length > 0) {
        upcomingEventsArray.sort((a, b) => new Date(a.start_date) - new Date(b.start_date));
      }
    }
  }

  async openPopup(registerObject, token) {
    this.setState({ popup: true, popupLoader: true, accessToken: token });
    const shows = [
      {
        name: 'Romance Travel Xpo',
        signedUp: registerObject.romance,
        ics: 'https://front.travpromobile.com/848/romance-ii-2026.ics',
        id: 1855,
      },
      {
        name: 'Luxury Travel Xpo',
        signedUp: registerObject.luxury,
        ics: 'https://front.travpromobile.com/848/luxury-ii-2026.ics',
        id: 1853,
      },
      {
        name: 'Family Travel Xpo',
        signedUp: registerObject.family,
        ics: 'https://front.travpromobile.com/848/family-ii-2026.ics',
        id: 1851,
      },
      {
        name: 'Adventure Travel Xpo',
        signedUp: registerObject.adventure,
        ics: 'https://front.travpromobile.com/848/adventure-ii-2026.ics',
        id: 1854,
      },
    ];

    const signedUpFor = shows.filter((show) => show.signedUp);

    this.setState({ signedUpFor, popupLoader: false });
  }

  closePopup() {
    const { icsDownloaded } = this.state;
    if (!icsDownloaded) {
      toast.error('Please add the event to your calendar', {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    } else {
      this.setState({
        popup: false,
      });
      window.location.href = 'https://www.virtualtravelxpos.com/';
    }
  }

  render() {
    const {
      events,
      individualShow,
      individualShowData,
      shows,
      meetings,
      loading,
      date,
      popup,
      signedUpFor,
      popupLoader,
    } = this.state;
    let backgroundImage = 'https://front.travpromobile.com/713/intro.jpg';
    if (individualShow && individualShowData && individualShowData.splash_screen) {
      let imgixUrl = individualShowData.splash_screen;
      if (imgixUrl) {
        imgixUrl = imgixUrl.replace(
          'https://s3.amazonaws.com/developertool',
          'https://travprocdn.imgix.net/',
        );
        imgixUrl = `${imgixUrl}?width=${window.screen.width}`;
        backgroundImage = imgixUrl;
      }
    }

    return (
      <div className="attendeeView">
        {!loading && (
          <div
            className="attendeeView__bg"
            style={{
              backgroundImage: individualShow ? `url(${backgroundImage})` : '',
              backgroundColor: individualShowData ? individualShowData.primary_color : '#990099',
            }}
          />
        )}
        <div className="attendeeView__content">
          {loading && (
            <div className="loading">
              <FontAwesomeIcon icon={['fas', 'circle-notch']} spin />
            </div>
          )}
          {!loading && (
            <React.Fragment>
              <div className="attendeeView__content--logo">
                {individualShow && individualShowData.logo && individualShowData.name && (
                  <img src={individualShowData.logo} alt={individualShowData.name} />
                )}
                {!individualShow && <h1>{'VIRTUAL TRAVEL XPOS'}</h1>}
              </div>
              {individualShow && (
                <div className="attendeeView__content--date">
                  <h3>
                    {date}
                    <br />
                    {'12p-4p (ET) / 9a-1p (PT)'}
                  </h3>
                </div>
              )}
              <div className="attendeeView__content--intro">
                {individualShow ? (
                  <p>{individualShowData.description}</p>
                ) : (
                  <p>
                    {
                      'Each Xpo is free for travel advisors to attend and includes valuable breakout sessions, an exhibition floor, in-depth trainings, a network lounge and prize giveaways!'
                    }
                    <br />
                    <br />
                    {'All Xpos will feature Live Chats with exhibitors from '}
                    <strong>{'12p - 4p (ET) / 9a - 1p (PT)'}</strong>
                    {' on the event date and will then be accessible '}
                    <strong>{'on-demand for 30 days'}</strong>
                    {', so you can visit revisit the event on your own time.'}
                    <br />
                    <br />
                    {'Please select the VIRTUAL TRAVEL XPOS you wish to attend.\r'}
                  </p>
                )}
              </div>
              {!individualShow && (
                <div className="attendeeView__content--checkboxes">
                  <div className="checkboxes__item">
                    <label htmlFor="family">
                      <input
                        type="checkbox"
                        id="family"
                        checked={shows.length > 0 && shows.includes('family')}
                        onChange={(e) => this.handleChange(e)}
                      />
                      <div className="custom-check">
                        <FontAwesomeIcon icon={['fas', 'check']} />
                      </div>
                      <span>
                        <strong>{'Family Travel Xpo'}</strong> <br />
                        {'March 11, 2026'}
                      </span>
                    </label>
                  </div>
                  <div className="checkboxes__item">
                    <label htmlFor="luxury">
                      <input
                        type="checkbox"
                        id="luxury"
                        checked={shows.length > 0 && shows.includes('luxury')}
                        onChange={(e) => this.handleChange(e)}
                      />
                      <div className="custom-check">
                        <FontAwesomeIcon icon={['fas', 'check']} />
                      </div>
                      <span>
                        <strong>{'Luxury Travel Xpo'}</strong> <br />
                        {'May 12, 2026'}
                      </span>
                    </label>
                  </div>
                  <div className="checkboxes__item">
                    <label htmlFor="adventure">
                      <input
                        type="checkbox"
                        id="adventure"
                        checked={shows.length > 0 && shows.includes('adventure')}
                        onChange={(e) => this.handleChange(e)}
                      />
                      <div className="custom-check">
                        <FontAwesomeIcon icon={['fas', 'check']} />
                      </div>
                      <span>
                        <strong>{'Adventure Travel Xpo'}</strong> <br />
                        {'September 22, 2026'}
                      </span>
                    </label>
                  </div>
                  <div className="checkboxes__item">
                    <label htmlFor="romance">
                      <input
                        type="checkbox"
                        id="romance"
                        checked={shows.length > 0 && shows.includes('romance')}
                        onChange={(e) => this.handleChange(e)}
                      />
                      <div className="custom-check">
                        <FontAwesomeIcon icon={['fas', 'check']} />
                      </div>
                      <span>
                        <strong>{'Romance Travel Xpo'}</strong> <br />
                        {'November 4, 2026'}
                      </span>
                    </label>
                  </div>
                </div>
              )}
              <div className="attendeeForm__form">
                {/* <LoginForm /> */}
                <AttendeeForm
                  shows={shows}
                  meetings={meetings}
                  events={events}
                  individualShowData={individualShowData}
                  openPopup={this.openPopup}
                />
              </div>
            </React.Fragment>
          )}
        </div>
        {popup && (
          <div className="attendeeView__popup">
            <div className="attendeeView__popup--bg" />
            {!popupLoader && (
              <div className="attendeeView__popup--content">
                <h1 className="h1">{'Thanks for registering!'}</h1>

                {signedUpFor.length > 0 && (
                  <div className="signed-up">
                    <p>
                      {
                        'If you would like to participate in the meetings, please click the options below.'
                      }
                    </p>
                    <p>{'You are now registered for:'}</p>
                    {signedUpFor.map((show) => (
                      <div key={show.id} className="show-signedup">
                        <p>
                          <FontAwesomeIcon icon={['fas', 'check']} />
                          {show.name}
                        </p>
                        <a href={show.ics} onClick={() => this.setState({ icsDownloaded: true })}>
                          {'Add to Calendar'}
                        </a>

                        <button
                          type="button"
                          htmlFor="meetingOptIn"
                          className={[
                            'meeting-optin',
                            meetings.includes(show.id) ? 'active' : '',
                          ].join(' ')}
                          onClick={() => this.handleMeetingOptIn(show.id)}
                        >
                          {meetings.includes(show.id) && (
                            <FontAwesomeIcon icon={['fas', 'check']} />
                          )}
                          <span>{'Open for meeting requests'}</span>
                        </button>
                      </div>
                    ))}
                    <p>{'Please check your email for confirmation.'}</p>
                  </div>
                )}
                {/* <ToastContainer /> */}
                <button
                  type="button"
                  onClick={() => {
                    window.location.href = 'https://www.virtualtravelxpos.com/';
                  }}
                >
                  {'Close and return to VIRTUAL TRAVEL XPOS\r'}
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}
